module.exports = __webpack_public_path__ + "img/ctrl-pauli-x-root-dagger-1.7c86a4a3.svg";